<template>
  <div class="HeroError">
    <div class="HeroError--inner">
      <div class="HeroError--content">
        <div class="HeroError--title">
          <h1 v-html="$i18n.t('exception.error.header')">Attention</h1>
        </div>
        <article class="HeroError--lead">
          <p v-html="$i18n.t('exception.error.error.text')">An error occured, please contact the service line.</p>
        </article>
      </div>
    </div>
  </div>
</template>
<script>  
  export default {
       name: "ActivationError",
    data() {
        return {
        }
    }
  }
</script>
